export default __webpack_public_path__ + "static/media/logo-desktop.07e3c9c7.svg";